import React from "react";
import { rem } from "polished";
import styled from "styled-components/macro";

import colors from "../theme/colors";
import spacing from "../theme/spacing";
import ReactMarkdown from "react-markdown";

const ErrorMessageWrapper = styled.div`
  background: #f8d9dd;
  width: 100%;
  max-width: 650px;
  color: ${colors.error};
  line-height: 1.333;
  font-size: ${rem(15)};
  padding: ${rem(24)} ${rem(spacing.gutters)};
  margin-top: 17px;
  margin-bottom: 3rem;

  ul {
    margin: 13px 0 0;
    padding: 0 0 0 1.1em;

    li {
      color: #3c3c3c;
      font-size: ${rem(15)};
      line-height: 1.33;
      button {
        border: 0;
        margin: 0;
        padding: 0;
        background-color: transparent;
        text-decoration: underline;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }

  a {
    color: ${colors.blue};
    text-decoration: underline;
  }
`;

export const ErrorMessage: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  ...props
}) => {
  if (typeof children === "string") {
    return (
      <ErrorMessageWrapper {...props}>
        <ReactMarkdown source={children} renderers={{ paragraph: 'span' }} linkTarget="_blank" />
      </ErrorMessageWrapper>
    );
  }

  return <ErrorMessageWrapper {...props}>{children}</ErrorMessageWrapper>;
};

export default ErrorMessage;
